export default class Customer {
    uid: string | null = null;
    name = '';
    email = '';
    phone = '';
}
